
import { Component, Vue, Prop } from 'vue-property-decorator'
import { editWallet } from '@/api/product/smsAccount'
import { delObjEmptyKey } from '@/utils'

@Component({
  name: 'version',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private edit!: any
  private loading: boolean = false
  private editForm: any = this.edit

  // 运维机器人 Token
  // private devBotTokenVis: boolean = false
  // private openDevBotToken() {
  //   this.devBotTokenVis = true
  // }
  // private closeDevBotToken() {
  //   this.devBotTokenVis = false
  // }

  private back () {
    this.$emit('close', false)
  }

  private async onSubmit() {
    try {
      this.loading = true
      // delObjEmptyKey(this.editForm)
      if (this.editForm.active_time === '') {
        delete this.editForm.active_time
      }
      await editWallet(this.editForm).then(() => {
        this.$message({
          message: 'Create successful!',
          type: 'success'
        })
        this.loading = false
        this.back()
      })
    } catch (e) {
      // this.back()
      this.loading = false
    }
  }

  // 对所有数据进行分页处理 发送请求
  // private async hadleGetFilesListApi () {
  //   try {
  //     this.listLoading = true
  //     const params = {
  //       ...this.queryForm,
  //       page_size: this.pagesize,
  //       page: this.currentPage
  //     }
  //     await getAntSmsLog(params).then((res: any) => {
  //       this.list = res.results
  //       this.total = res.count
  //       this.listLoading = false
  //     })
  //   } catch (e) {
  //     this.listLoading = false
  //   }
  // }

  mounted () {
  }
}
